var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    viewBox: "0 0 48 48",
    height: 36,
    width: 36,
    className: "createSvgIcon__Svg-sc-1l8xi8d-0 loXvaP ability-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.912 23.605.912 3.402-2.41 1.59.56-2.445-1.689-.762-5.939.51 5.581-4.87-3.916-1.516 4.283-1.148-1.683-2.249 1.444-.657-1.382-3.14 3.454.29-2.88-5.71 7.725 4.141.18-4.368 3.716 2.784 1.512-.405L26.74 2.75l2.464 9.196L32.732 11l-2.616 4.346c-.858-1.525-3.936-4.21-9.378-2.753-6.803 1.823-6.366 8.997-5.825 11.012Zm17.218-3.263c.41-2-.239-2.906-.979-3.653l3.082-1.096-.166 1.395 7.87-.354c-2.619.972-8.248 3.075-9.807 3.708Zm1.02 2.292 4.224-.862 4.396 1.793-4.637.837-3.984-1.768Zm-5.153 19.068-.452 1.336-1.385.371a5.004 5.004 0 0 0-.1-.108c-.198-.21-.468-.498-.582-.924-.162-.605.052-3.165.18-4.369l-3.14-11.715-1.007.27-.44-1.638 1.065-2.58-.959-.553-.54-2.016 1.008-.27-.203-.756.756-.202-.513-.403-1.763.473-1.208 1.539 3.072 11.463.638.369.473 1.763-2.236-1.29-3.376-12.598 2.508-3.237 1.764-.473.83-1.437.882-.237.439 1.638.881-.236 1.438.83.169.63.755-.203.203.756 1.134-.304.574 2.142-.965.933 2.37 1.795.44 1.638-1.134.304 3.139 11.715c.799.461 2.297 3.03 2.466 3.66.135.504.09 1.01.052 1.201l-1.386.371-1.186-.897-4.66 1.249Zm.602-16.903-5.039 1.35 3.173 11.841.63-.169.553-.958 2.393-.641.959.553.504-.135-3.173-11.841Zm1.612 13.07-1.386.37-.646 1.119.237.882 3.023-.81-.27-1.008-.958-.554Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragment);
export default __webpack_public_path__ + "static/media/fragment.6352daa7.svg";
export { ForwardRef as ReactComponent };